var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M300.051,326.987v30.759c0,7.867,5.216,14.781,12.779,16.942l73.081,20.88  c22.892,6.54,39.975,25.675,43.89,49.159l7.793,46.754c1.79,10.741-6.492,20.517-17.38,20.517H91.787  c-10.888,0-19.171-9.777-17.38-20.517l7.793-46.754c3.914-23.485,20.997-42.619,43.89-49.159l73.081-20.88  c7.565-2.162,12.779-9.076,12.779-16.942v-30.759H300.051z",
    fill: "#242424",
    "data-original": "#00bea5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256.001,441.519c37.232,0,68.291-26.398,75.503-61.495l-18.673-5.335  c-7.565-2.161-12.779-9.076-12.779-16.942v-30.759H211.95v30.759c0,7.867-5.216,14.781-12.779,16.942l-18.673,5.335  C187.709,415.122,218.769,441.519,256.001,441.519z",
    fill: "#b48764",
    "data-original": "#b48764"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M300.051,335.798l-24.228-8.81H211.95v30.759c0,7.867-5.216,14.781-12.779,16.942l-18.673,5.335  v0.001C254.767,415.443,300.051,335.798,300.051,335.798z",
    fill: "#966d50",
    "data-original": "#966d50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M379.343,36.253c2.203-15.418,18.722-7.342,18.722-7.342c-11.013-57.266-125.911-8.076-125.911-8.076  l10.646-11.013c-53.503-30.147-120.405,18.722-120.405,18.722c-20.924-6.608-73.785,13.95-73.785,64.24  c0,51.393,26.43,128.482,26.43,128.482h290.734c0,0,8.81-96.912,8.81-132.152S379.343,36.253,379.343,36.253z",
    fill: "#553732",
    "data-original": "#553732",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M398.064,28.911c-36.342-45.519-104.07,10.646-104.07,10.646  c35.241,2.753,31.386,44.601,31.386,44.601c-7.709-12.665-19.272-10.462-19.272-10.462c-1.652,40.196-28.633,79.291-43.133,86.266  l0.735,61.304h142.063c0,0,8.81-96.912,8.81-132.152s-35.241-52.861-35.241-52.861C381.545,20.835,398.064,28.911,398.064,28.911z",
    fill: "#64463c",
    "data-original": "#64463c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M388.153,203.646v-79.291H123.849v79.291c-9.731,0-17.62,7.888-17.62,17.62v17.62  c0,9.731,7.889,17.62,17.62,17.62c0.486,0,0.942-0.105,1.417-0.143c5.272,29.593,25.39,54.917,53.963,66.346l44.051,17.62  c21.004,8.402,44.436,8.402,65.441,0l44.051-17.62c28.575-11.429,48.693-36.753,53.963-66.346c0.476,0.039,0.932,0.143,1.417,0.143  c9.731,0,17.62-7.889,17.62-17.62v-17.62C405.773,211.534,397.884,203.646,388.153,203.646z",
    fill: "#c39772",
    "data-original": "#c39772",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M352.912,124.354H123.849v79.291c-9.731,0-17.62,7.888-17.62,17.62v17.62  c0,9.731,7.889,17.62,17.62,17.62c0.486,0,0.942-0.105,1.417-0.143c5.272,29.593,25.39,54.917,53.963,66.346l44.051,17.62  c9.943,3.978,20.432,6.006,30.948,6.218c-29.898-13.268-52.048-34.709-66.423-52.23c-12.912-15.74-19.907-35.449-19.907-55.808  v-64.659c0-9.137,6.981-16.876,16.094-17.533c14.479-1.044,27.869-5.533,36.767-5.533c26.43,0,61.671-8.81,114.532,8.81  c34.461,11.487,44.051-8.81,44.051-8.81L352.912,124.354z",
    fill: "#b48764",
    "data-original": "#b48764"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M132.659,203.646c0,0,0-44.051,26.43-70.481c0,0,17.115,6.46,52.861,0c22.851-4.13,27.165,0,27.165,0  s-1.836,18.171-27.165,26.43c0,0,26.43,17.62,52.861-8.81l-1.836,9.177c0,0,27.898,5.506,52.861-23.861  c0,0,9.545-0.735,19.456,5.873c17.292,11.528,35.241,4.894,35.241,4.894s17.62,21.536,17.62,56.777h17.62v-96.912H115.038v96.912  h17.62V203.646z",
    fill: "#553732",
    "data-original": "#553732",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256.001,300.557c-15.663,0-30.315-3.854-40.196-10.578c-4.022-2.736-5.068-8.217-2.327-12.238  c2.731-4.017,8.217-5.064,12.238-2.327c6.926,4.71,18.248,7.524,30.285,7.524c12.037,0,23.359-2.814,30.285-7.524  c4.031-2.74,9.503-1.699,12.238,2.327c2.74,4.022,1.695,9.503-2.327,12.238C286.315,296.703,271.663,300.557,256.001,300.557z",
    fill: "#966d50",
    "data-original": "#966d50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M315.836,136.102c0,0,9.545-0.735,19.456,5.874c17.292,11.528,35.241,4.894,35.241,4.894  s17.62,21.536,17.62,56.777h17.62v-96.912H299.467c-9.286,26.635-26.082,48.221-36.49,53.228  C262.975,159.962,290.873,165.468,315.836,136.102z",
    fill: "#64463c",
    "data-original": "#64463c",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M189.925,238.886L189.925,238.886c-7.298,0-13.215-5.917-13.215-13.215v-8.81   c0-7.298,5.917-13.215,13.215-13.215l0,0c7.298,0,13.215,5.917,13.215,13.215v8.81C203.14,232.97,197.223,238.886,189.925,238.886z   ",
    fill: "#5a4137",
    "data-original": "#5a4137",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M322.077,238.886L322.077,238.886c-7.298,0-13.215-5.917-13.215-13.215v-8.81   c0-7.298,5.917-13.215,13.215-13.215l0,0c7.298,0,13.215,5.917,13.215,13.215v8.81C335.292,232.97,329.375,238.886,322.077,238.886   z",
    fill: "#5a4137",
    "data-original": "#5a4137",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M256.001,459.14c44.307,0,82.936-31.168,92.435-74.277l-16.922-4.835l-0.01-0.002   c-7.212,35.095-38.271,61.494-75.503,61.494s-68.291-26.398-75.503-61.494l-0.01,0.002l-16.922,4.835   C173.064,427.971,211.692,459.14,256.001,459.14z",
    fill: "#2d5350",
    "data-original": "#00aa9a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M101.032,409.893c-9.734,9.093-16.558,21.181-18.833,34.836l-7.793,46.754   C72.617,502.223,80.898,512,91.786,512h49.681v-30.222c0-9.003-2.759-17.789-7.904-25.176L101.032,409.893z",
    fill: "#2d5350",
    "data-original": "#00aa9a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M410.969,409.893c9.734,9.093,16.558,21.181,18.833,34.836l7.793,46.754   c1.79,10.74-6.492,20.517-17.38,20.517h-49.681v-30.222c0-9.003,2.759-17.789,7.904-25.176L410.969,409.893z",
    fill: "#2d5350",
    "data-original": "#00aa9a",
    className: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.f2695feee8cfd1c123382eab9c28a142.svg";
export { ForwardRef as ReactComponent };